"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileDescriptionExpandable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const clsx_1 = require("clsx");
const app_1 = require("app");
const VISIBLE_LINES_COUNT_ON_MOBILE = 3;
const VISIBLE_AREA_MAX_HEIGHT = 24 * VISIBLE_LINES_COUNT_ON_MOBILE;
const TileDescriptionExpandable = ({ description, showLessBtnLabel, showMoreBtnLabel, }) => {
    const [isContentOverflowing, setContentOverflowing] = React.useState(false);
    const [isOpened, setIsOpened] = React.useState(false);
    const descriptionRef = (0, app_1.useExternalIcon)('mt-0.5 self-center text-[length:inherit]');
    const onExpandBtnClick = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsOpened(true);
    }, []);
    const onCollapseBtnClick = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsOpened(false);
    }, []);
    React.useEffect(() => {
        const descriptionEl = descriptionRef.current;
        if (!isContentOverflowing &&
            descriptionEl &&
            descriptionEl.scrollHeight > VISIBLE_AREA_MAX_HEIGHT) {
            setContentOverflowing(true);
        }
        else if (isContentOverflowing &&
            descriptionEl &&
            descriptionEl.scrollHeight <= VISIBLE_AREA_MAX_HEIGHT) {
            setContentOverflowing(false);
        }
    }, [isContentOverflowing, setContentOverflowing]);
    return description ? ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)('body-md text-secondary sm:line-clamp-none', isOpened ? 'line-clamp-none' : 'line-clamp-3'), children: (0, jsx_runtime_1.jsx)("div", { ref: descriptionRef, children: (0, app_1.StringToHTML)(description) }) }), isContentOverflowing && ((0, jsx_runtime_1.jsxs)("div", { className: "expandable-text-controls", children: [(0, jsx_runtime_1.jsx)("button", { className: (0, clsx_1.clsx)('expandable-text-read-more text-btn-primary', isOpened ? 'hidden' : 'block'), onClick: onExpandBtnClick, children: showMoreBtnLabel }), (0, jsx_runtime_1.jsx)("button", { className: (0, clsx_1.clsx)('expandable-text-read-less text-btn-primary', isOpened ? 'block' : 'hidden'), onClick: onCollapseBtnClick, children: showLessBtnLabel })] }))] })) : null;
};
exports.TileDescriptionExpandable = TileDescriptionExpandable;
